import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { STATUSES, LABEL_KEYS } from '@dashboard/components/SyncMonitor/statuses';
import classes from './GlobalDayDetail.module.scss';

export default function GlobalDayDetail({ date, counts, onClose }) {
  const { t } = useTranslation('dashboard\\SyncMonitorView', {
    useSuspense: false,
  });

  if (!date) {
    return (
      <div className={classes.placeholder}>
        <p>{t('globalDetailPlaceholder')}</p>
      </div>
    );
  }

  const total = counts?.total ?? 0;
  const success = (counts?.processed ?? 0) + (counts?.duplicate ?? 0);
  const ratio = total > 0 ? success / total : 0;

  return (
    <div className={classes.panel}>
      <div className={classes.header}>
        <div>
          <h3 className={classes.title}>{date}</h3>
          <p className={classes.subtitle}>
            {t('globalDetailSubtitle', { count: total })}
          </p>
        </div>
        <button
          type="button"
          className={classes.closeBtn}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>

      <div className={classes.successCard}>
        <div className={classes.successPct}>{Math.round(ratio * 100)}%</div>
        <div className={classes.successLabel}>{t('globalDetailSuccess')}</div>
        <div className={classes.successRatio}>{success} / {total}</div>
      </div>

      <ul className={classes.list}>
        {STATUSES.map((s) => {
          const n = counts?.[s] ?? 0;
          const pct = total > 0 ? (n / total) * 100 : 0;
          return (
            <li key={s} className={classes.row}>
              <span className={`${classes.dot} ${classes[s]}`} />
              <span className={classes.label}>{t(LABEL_KEYS[s])}</span>
              <span className={classes.bar}>
                <span
                  className={`${classes.barFill} ${classes[s]}`}
                  style={{ width: `${pct}%` }}
                />
              </span>
              <span className={classes.count}>{n}</span>
              <span className={classes.pct}>{pct.toFixed(1)}%</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

GlobalDayDetail.propTypes = {
  date: PropTypes.string,
  counts: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

GlobalDayDetail.defaultProps = {
  date: null,
  counts: null,
};
